<template>
  <v-container class="mr-5 ml-5 roma-link">
      <v-row class="mr-5">
          <v-col>
              <v-card height="100%"  elevation="2" class="d-flex flex-column align-center">
                    <img
                    src="@/assets/images/link.jpg"
                    class="img"
                    />
                    <v-card-text>
                        <!-- <h4 class="text-center font-weight-bold">RECURSO DE ENLACE EXTERNO</h4> -->
                        <p class="text-center">Dar clic en el botón para redireccionar:</p>
                        
                        <!-- <p class="text-center">
                            Enlace: 
                            <a :href="url" target="_blank">Link</a>
                        </p> -->
                        
                    </v-card-text>
                        <a :href="url" target="_blank" class="white--text link">
                             
                            <v-btn class="text-center btn" color="primary">
                                <v-icon class="mr-3">
                                mdi-link
                                </v-icon>
                                Link
                             </v-btn>
                        </a>
              </v-card>
          </v-col>
      </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
export default {
    computed: {
        ...mapGetters({
            resource: "getCurrentResource"
        }),
        url() {
            return this.resource.link;
        }
    },

    // mounted() {
    //     this.actionClickOnResource({ resourceId: this.resource.resourcesId, activityId: this.resource.activity.activityLessonId});
    // },

    // methods: {
    //     ...mapActions({
    //         actionClickOnResource: "actionClickOnResource"
    //     })
    // }
}
</script>

<style  lang="scss">
.roma-link {

    .row{
        height: 100%;
        .col{
            height: 100%;
        }
    }
    .link{
        text-decoration: none;
    }

    .btn{
        width: 150px;
        a{
            width: 100%;
        }
    }

    .img{
        height: 200px ;
        width: 200px;
    }

}
</style>